import { useState } from "react";

export type Pagination = {
  page: number;
  size: number;
};

export const usePagination = () => useState<Pagination>({ page: 0, size: 10 });
